<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/']">Home</a>
      </li>
      <li>
        <a [routerLink]="['/', 'ticket', 'suche', 'index']">
          <i class="fa fa-ticket"></i>
          Tickets
        </a>
      </li>
      <li>Ticket</li>
    </ul>
  </div>
</div>

@if (ticket) {
  <div class="page-content page-frame overflow-y-auto">
    <div class="page-sheet grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <div class="main-content lg:col-span-2 flex flex-col gap-4">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <section class="bm-card bm-card-sm bm-card-border border-base-300">
            <div class="bm-card-body">
              <h3 class="bm-card-title bm-card-title-top bg-base-100">Stammdaten</h3>
              <dl class="bm-dl gap-x-4 align-items-center">
                <dt>HAWK ID</dt>
                <dd>{{ ticket.order_nr }}</dd>

                <dt (click)="editExtNr = !editExtNr">
                  Externe Nr.
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                <dd>
                  @if (editExtNr) {
                    <hawk-shared-edit-input
                      [textValue]="ticket.external_order_nr"
                      (saveClicked)="saveExtNr($event)"
                      (cancelClicked)="editExtNr = false"
                    />
                  } @else {
                    {{ ticket.external_order_nr }}
                  }
                </dd>

                <dt (click)="editProject = !editProject">
                  Projekt
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                <dd>
                  @if (editProject) {
                    <hawk-shared-edit-input
                      [selectValue]="ticket.project_id"
                      [selectOptions]="metaData.projects"
                      [modus]="'select'"
                      (saveClicked)="saveProject($event)"
                      (cancelClicked)="editProject = false"
                    />
                  } @else {
                    <a [routerLink]="['/', 'projekt', ticket.project_id]" target="_blank" class="bm-link">{{
                      ticket.project_name
                    }}</a>
                  }
                </dd>

                <dt>Erstellt</dt>
                <dd>{{ ticket.date_created | date: "dd.MM.yy HH:mm" }}</dd>

                <dt (click)="editDateSla = !editDateSla">
                  SLA Kunde
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                <dd>
                  @if (editDateSla) {
                    <hawk-shared-edit-input
                      [textValue]="ticket.datesla"
                      [modus]="'date'"
                      (saveClicked)="saveDateSla($event)"
                      (cancelClicked)="editDateSla = false"
                    />
                  } @else {
                    {{ ticket.datesla | date: "dd.MM.yy HH:mm" }}
                  }
                </dd>
                <dt>SLA berechnet</dt>
                <dd></dd>
              </dl>
            </div>
          </section>
          <section class="bm-card bm-card-sm bm-card-border border-base-300">
            <div class="bm-card-body">
              <h3 class="bm-card-title bm-card-title-top bg-base-100">Adresse</h3>
              @let storeEditable = !ticket.store_id;
              <dl class="bm-dl gap-x-4 align-items-center">
                <dt (click)="showModal = 'store'">
                  Filiale
                  <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                    <fa-icon [icon]="['far', 'edit']" />
                  </button>
                </dt>
                <dd>
                  <a [routerLink]="['/filiale', ticket.store_id]" target="_blank" class="bm-link">
                    {{ ticket.store_nr }}
                  </a>
                </dd>

                <dt
                  [class.bm-dt-edit-label]="storeEditable"
                  (click)="editAddrCompany = !storeEditable ? false : !editAddrCompany"
                >
                  Firma
                  @if (storeEditable) {
                    <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                      <fa-icon [icon]="['far', 'edit']" />
                    </button>
                  }
                </dt>
                <dd>
                  @if (editAddrCompany) {
                    <hawk-shared-edit-input
                      [textValue]="ticket.address_company"
                      (saveClicked)="metaUpdate('address_company', $event); editAddrCompany = false"
                      (cancelClicked)="editAddrCompany = false"
                    />
                  } @else {
                    {{ ticket.address_company }}
                  }
                </dd>
                <dt
                  [class.bm-dt-edit-label]="storeEditable"
                  (click)="editAddrName = !storeEditable ? false : !editAddrName"
                >
                  Name
                  @if (storeEditable) {
                    <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                      <fa-icon [icon]="['far', 'edit']" />
                    </button>
                  }
                </dt>
                <dd>
                  @if (editAddrName) {
                    <div class="flex flex-col gap-1">
                      <hawk-shared-edit-input
                        [textValue]="ticket.address_firstname"
                        (saveClicked)="metaUpdate('address_firstname', $event); editAddrName = false"
                        (cancelClicked)="editAddrName = false"
                      />
                      <hawk-shared-edit-input
                        [textValue]="ticket.address_lastname"
                        (saveClicked)="metaUpdate('address_lastname', $event); editAddrName = false"
                        (cancelClicked)="editAddrName = false"
                      />
                    </div>
                  } @else {
                    {{ ticket.address_firstname }} {{ ticket.address_lastname }}
                  }
                </dd>
                <dt
                  [class.bm-dt-edit-label]="storeEditable"
                  (click)="editAddrStreet = !storeEditable ? false : !editAddrStreet"
                >
                  Straße
                  @if (storeEditable) {
                    <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                      <fa-icon [icon]="['far', 'edit']" />
                    </button>
                  }
                </dt>
                <dd>
                  @if (editAddrStreet) {
                    <div class="flex flex-col gap-1">
                      <hawk-shared-edit-input
                        [textValue]="ticket.address_street"
                        (saveClicked)="updateNormalizedAddressStreet($event); editAddrStreet = false"
                        (cancelClicked)="editAddrStreet = false"
                      />
                    </div>
                  } @else {
                    {{ ticket.address_street }}
                  }
                </dd>
                <dt
                  [class.bm-dt-edit-label]="storeEditable"
                  (click)="editAddrZipCity = !storeEditable ? false : !editAddrZipCity"
                >
                  Ort
                  @if (storeEditable) {
                    <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                      <fa-icon [icon]="['far', 'edit']" />
                    </button>
                  }
                </dt>
                <dd>
                  @if (editAddrZipCity) {
                    <div class="flex flex-col gap-1">
                      <hawk-shared-edit-input
                        [textValue]="ticket.address_zip"
                        (saveClicked)="metaUpdate('address_zip', $event); editAddrZipCity = false"
                        (cancelClicked)="editAddrZipCity = false"
                      />
                      <hawk-shared-edit-input
                        [textValue]="ticket.address_city"
                        (saveClicked)="metaUpdate('address_city', $event); editAddrZipCity = false"
                        (cancelClicked)="editAddrZipCity = false"
                      />
                    </div>
                  } @else {
                    {{ ticket.address_zip }} {{ ticket.address_city }}
                  }
                </dd>
                <dt
                  [class.bm-dt-edit-label]="storeEditable"
                  (click)="editAddrCountry = !storeEditable ? false : !editAddrCountry"
                >
                  Land
                  @if (storeEditable) {
                    <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                      <fa-icon [icon]="['far', 'edit']" />
                    </button>
                  }
                </dt>
                <dd>
                  @if (editAddrCountry) {
                    <hawk-shared-edit-input
                      [textValue]="ticket.address_country"
                      (saveClicked)="metaUpdate('address_country', $event); editAddrCountry = false"
                      (cancelClicked)="editAddrCountry = false"
                    />
                  } @else {
                    {{ ticket.address_country }}
                  }
                </dd>
              </dl>
            </div>
          </section>
          <section class="bm-card bm-card-sm bm-card-border border-base-300">
            <div class="bm-card-body">
              <h3 class="bm-card-title bm-card-title-top bg-base-100" (click)="editContact()">
                Kontakt
                <button type="button" class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
                  <fa-icon [icon]="['far', 'edit']" />
                </button>
              </h3>
              <dl class="bm-dl gap-x-4 align-items-center">
                <dt>Ansprechpartner</dt>
                <dd>{{ ticket.contact_name }}</dd>
                <dt>E-Mail</dt>
                <dd>
                  <a href="mailto://{{ ticket.contact_email }}">{{ ticket.contact_email }}</a>
                </dd>
                <dt>Telefon</dt>
                <dd>
                  <a href="tel://{{ ticket.contact_phone }}">{{ ticket.contact_phone }}</a>
                </dd>
                <dt>Filialtelefon</dt>
                <dd>
                  @if (!editStoreContact) {
                    @for (nr of ticket.store_contact_nr; track $index) {
                      <a href="tel://{{ nr }}">{{ nr }}</a>
                    } @empty {
                      -
                    }
                  }
                </dd>
              </dl>
            </div>
          </section>
          <section class="bm-card bm-card-sm bm-card-border border-base-300">
            <div class="bm-card-body">
              <h3 class="bm-card-title bm-card-title-top bg-base-100">
                Ticketgruppe
                <button
                  type="button"
                  class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost"
                  (click)="showModal = 'ticket_group'"
                >
                  <fa-icon [icon]="['far', 'plus']" />
                </button>
              </h3>
              <div class="relative h-100">
                <div class="absolute inset-0 px-0 pb-0 box-border">
                  @if (ticketGroup) {
                    <fieldset
                      class="bm-fieldset grid grid-cols-[max-content_1fr] p-0 gap-x-2 gap-y-1 overflow-y-auto max-h-full"
                    >
                      @for (group_ticket of ticketGroup.tickets; track group_ticket.id) {
                        @if (group_ticket.id != ticket.id) {
                          <!-- Zeile 1: Order-Nr + Einsätze + Löschen -->
                          <label class="bm-fieldset-label">
                            <a
                              class="bm-link"
                              [routerLink]="['/ticket/suche']"
                              [queryParams]="{ order_number: group_ticket.order_nr }"
                              target="_blank"
                            >
                              {{ group_ticket.order_nr }}
                            </a>
                          </label>
                          <div class="flex items-center gap-1">
                            <div class="me-auto flex flex-wrap gap-1">
                              @for (operation of group_ticket.operations; track operation.id) {
                                <span class="text-xs">
                                  @if (operation.operation_date) {
                                    {{ operation.operation_date | date: "dd.MM.yy" }}
                                  }
                                  @for (user of operation.users; track user.id) {
                                    <a class="bm-link" [routerLink]="['/benutzer', user.id]" [tooltip]="user.name">
                                      {{ shortName(user.name) }}
                                    </a>
                                  }
                                </span>
                              }
                            </div>
                            <fa-icon
                              class="shrink-0"
                              [icon]="['far', 'trash']"
                              style="cursor: pointer"
                              (click)="openRemoveTicketFromGroupDialog(group_ticket.id)"
                            />
                          </div>
                          <!-- Zeile 2: Status + Priorität -->
                          <div class="col-span-2 flex flex-wrap gap-1 -mt-1 mb-1">
                            <span class="bm-badge bm-badge-neutral bm-badge-xs">{{ group_ticket.status.label || group_ticket.status.name }}</span>
                            <span class="bm-badge bm-badge-neutral bm-badge-xs">{{ group_ticket.priority.name }}</span>
                          </div>
                        }
                      }
                    </fieldset>
                  }
                </div>
              </div>
            </div>
          </section>
        </div>

        <span id="storeSubbox" class="-mt-4"></span>
        @if (selectedStep) {
          <hawk-store-subbox
            [ticket]="ticket"
            [operation]="selectedOperation"
            [selectedStep]="selectedStep"
            [resetStoreUnit]="resetStoreUnit.asObservable()"
          />
        }

        <section class="bm-card bm-card-sm bm-card-border border-base-300">
          <div class="bm-card-body">
            <label class="bm-card-title bm-card-title-top bg-base-100" (click)="editDescription = !editDescription">
              Fehlerbeschreibung
            </label>
            <div></div>
            @if (!editDescription) {
              <div class="grid grid-cols-2 gap-4">
                <div class="description break-words" [innerHtml]="convertLinebreaks(ticket.description, true)"></div>

                <div class="description break-words">
                  Kurzinfo: {{ ticket.short_information || "-" }}<br />
                  Bekannte Seriennummern: {{ ticket.known_serial_numbers || "-" }}<br />
                  <small>(ohne Leerzeichen mit | getrennt)</small>
                </div>
              </div>
            } @else {
              <div>
                <hawk-shared-edit-input
                  [textValue]="ticket.description"
                  [modus]="'textarea'"
                  (saveClicked)="saveDescription($event)"
                  (cancelClicked)="editDescription = false"
                />
              </div>
              <div>
                <label class="bm-label mt-4">Kurzinfo</label>
                <hawk-shared-edit-input
                  [textValue]="ticket.short_information"
                  (saveClicked)="saveShortInfo($event)"
                  (cancelClicked)="editDescription = false"
                />
              </div>
              <div>
                <label class="bm-label mt-4">Seriennummern (ohne Leerzeichen mit | getrennt)</label>
                <hawk-shared-edit-input
                  [textValue]="ticket.known_serial_numbers"
                  (saveClicked)="saveKnownSerialNumbers($event)"
                  (cancelClicked)="editDescription = false"
                />
              </div>
            }
          </div>
        </section>

        <section>
          <div role="tablist" class="bm-tabs bm-tabs-lift w-full">
            <a (click)="createEmptyOperation()" class="bm-tab"> Neuer Einsatz </a>
            @for (operation of operations; track $index) {
              <button
                role="tab"
                class="bm-tab"
                [attr.aria-selected]="operationActive(operation)"
                [attr.bm-tab-active]="operationActive(operation)"
                (click)="selectOperation(operation)"
              >
                {{ operation.tech_short }} {{ operation.operation_date | date: "dd.MM.yyyy HH:mm" }}
                @if (operation.status === "DONE") {
                  <fa-icon [icon]="['far', 'check']" />
                }
              </button>
            }
            <div class="bm-tab-content bg-base-100 border-t-base-300 pt-3">
              @for (operation of operations; track $index) {
                @if (operationActive(operation)) {
                  <hawk-operation-subpage
                    [operation]="operation"
                    [technicians]="technicians"
                    [articleTemplates]="articleTemplates"
                    [articleSummary]="articleSummary"
                    [ticket]="ticket"
                    [isBookkeeper]="isBookkeeper"
                    [canReject]="canReject()"
                    (selectStep)="selectStep($event)"
                    (reloadTicket)="handleReloadTicket($event)"
                  />
                }
              }
            </div>
          </div>
        </section>
      </div>

      <aside class="flex flex-col gap-4">
        <section class="bm-card bm-card-sm bm-card-border border-base-300">
          <mgl-map
            class="aspect-video z-1 max-h-60"
            [style]="'mapbox://styles/mapbox/streets-v9'"
            [zoom]="[9]"
            [center]="position"
          >
            @for (marker of markerData; track $index) {
              <div>
                @if (marker.lat && marker.lng) {
                  <mgl-marker [lngLat]="[marker.lng, marker.lat]">
                    <div
                      class="marker"
                      [style.borderColor]="'black'"
                      [style.backgroundColor]="marker.color"
                      title="{{ marker.text }}"
                    ></div>
                  </mgl-marker>
                }
              </div>
            }
            @if (travelLine) {
              <mgl-geojson-source id="travel-line" [data]="travelLine" />
              <mgl-layer
                id="travel-line-layer"
                type="line"
                source="travel-line"
                [paint]="{ 'line-color': '#0a7d2c', 'line-width': 3, 'line-dasharray': [2, 1] }"
              />
            }
          </mgl-map>
          <label class="bm-card-title bm-card-title-top bg-base-100 rounded z-2 left-4"> Karte </label>
        </section>
        <div class="flex flex-col gap-4">
          @if (metaData) {
            <section class="flex-1 bm-card bm-card-sm bm-card-border border-base-300 p-0">
              <div class="bm-card-body">
                <h3 class="bm-card-title bm-card-title-top bg-base-100">Aktionen</h3>
                <dl class="bm-dl gap-x-4 align-items-center">
                  <dt (click)="showModal = 'status'">
                    Status
                    <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                      <fa-icon [icon]="['far', 'edit']" />
                    </button>
                  </dt>
                  <dd>{{ metaData.status.label || metaData.status.name }}</dd>
                  <dt (click)="showModal = 'prio'">
                    Priorität
                    <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                      <fa-icon [icon]="['far', 'edit']" />
                    </button>
                  </dt>
                  <dd>{{ metaData.priority.name }}</dd>
                  <dt (click)="showModal = 'appointment'">
                    Terminv&shy;ereinbarung
                    <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                      <fa-icon [icon]="['far', 'edit']" />
                    </button>
                  </dt>
                  <dd>
                    {{ ticket.appointment_date | date: "dd.MM.yyyy HH:mm" }}<br />
                    @if (ticket.appointment_contact) {
                      <span>({{ ticket.appointment_contact }})</span>
                    }
                  </dd>
                  <dt (click)="showModal = 'time_estimation'">
                    Kalkulierte Arbeitszeit
                    <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                      <fa-icon [icon]="['far', 'edit']" />
                    </button>
                  </dt>
                  <dd>{{ ticket.time_estimation }} min</dd>
                  <dt>Abrechnungs&shy;besonderheiten</dt>
                  <dd>{{ metaData.special_billing ? "ja" : "nein" }}</dd>
                  <dt>Dokumentationen</dt>
                  <dd><a href="{{ metaData.additional_documentation }}" class="bm-link">Link</a></dd>
                  <dt (click)="editDispatcher = true">
                    Dispatcher
                    <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                      <fa-icon [icon]="['far', 'edit']" />
                    </button>
                  </dt>
                  <dd>
                    @if (editDispatcher) {
                      <hawk-shared-edit-input
                        [selectValue]="ticket.dispatcher_id"
                        [selectOptions]="dispatchers"
                        [modus]="'select'"
                        (saveClicked)="saveDispatcher($event); editDispatcher = false"
                        (cancelClicked)="editDispatcher = false"
                      />
                    } @else {
                      {{ selectedDispatcher }}
                    }
                  </dd>
                  <dt (click)="openStoreInfoEditor()">
                    Filialinfo
                    <button type="button" class="bm-btn bm-btn-sm bm-btn-ghost">
                      <fa-icon [icon]="['far', 'edit']" />
                    </button>
                  </dt>
                  <dd>
                    @if (storeInfoStationCount > 0) {
                      {{ storeInfoStationCount }} Station{{ storeInfoStationCount === 1 ? "" : "en" }}
                    } @else {
                      keine
                    }
                  </dd>
                </dl>
              </div>
            </section>
          }
          <section class="flex-1 bm-card bm-card-sm bm-card-border border-base-300 p-0">
            <div class="bm-card-body">
              <h3 class="bm-card-title bm-card-title-top bg-base-100" (click)="editCustomerContact()">
                Kundenkontakt
                <button type="button" class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
                  <fa-icon [icon]="['far', 'edit']" />
                </button>
              </h3>
              @if (hasCustomerContact) {
                <p class="text-sm">
                  {{ ticket.customer_contact_salutation }} {{ ticket.customer_contact_name }}
                  @if (ticket.customer_contact_email) {
                    ·
                    <a href="mailto://{{ ticket.customer_contact_email }}" class="bm-link">{{
                      ticket.customer_contact_email
                    }}</a>
                  }
                </p>
              }
            </div>
          </section>
          <section class="flex-1 bm-card bm-card-sm bm-card-border border-base-300 p-0">
            <div class="bm-card-body">
              <label class="bm-card-title bm-card-title-top bg-base-100">Navigation</label>
              <nav class="flex flex-row gap-2 flex-wrap">
                <a [href]="planningAssistantLink" class="bm-btn bm-btn-primary">Planungsassistent</a>
                @if (technicianWarehousePresent()) {
                  <a
                    [routerLink]="['/', 'lager', mainTechnicianWarehouse()]"
                    target="_blank"
                    class="bm-btn bm-btn-primary"
                  >
                    Materialbestand Techniker
                  </a>
                }
                @if (technicianPresent()) {
                  <a
                    [routerLink]="['/', 'ticket', 'suche']"
                    [queryParams]="{
                      operation_date_from: operationDate() | date: 'dd.MM.yyyy',
                      operation_date_to: operationDate() | date: 'dd.MM.yyyy',
                      technician_ids: mainTechnician().id,
                    }"
                    target="_blank"
                    class="bm-btn bm-btn-primary"
                  >
                    Tagestickets Techniker
                  </a>
                }
                <a (click)="showModal = 'quick_actions'; (false)" class="bm-btn bm-btn-primary">
                  <fa-icon [icon]="['fas', 'bolt']" /> Schnellaktionen
                </a>
                <a (click)="showModal = 'delete'; (false)" class="bm-btn">
                  <fa-icon [icon]="['fas', 'trash']" class="text-error" /> Etwas löschen
                </a>
              </nav>
            </div>
          </section>
        </div>

        <hawk-note-subpage [operation]="selectedOperation" [ticketId]="ticket.id" />
      </aside>
    </div>
  </div>
}

@if (showModal === "contact") {
  <dialog class="bm-modal" open (document:keydown.escape)="showModal = ''">
    <div class="bm-modal-box p-0">
      <div class="flex flex-row p-4">
        <h3 class="flex-fill text-lg font-bold">Kontaktdaten</h3>
      </div>
      <form [formGroup]="ticketContactForm" class="px-4">
        <fieldset class="bm-fieldset">
          <label class="bm-fieldset-label">Ansprechpartner</label>
          <input type="text" class="bm-input w-full" formControlName="contact_name" />

          <label class="bm-fieldset-label">E-Mail</label>
          <input type="text" class="bm-input w-full" formControlName="contact_email" />

          <label class="bm-fieldset-label">Telefon</label>
          <input type="text" class="bm-input w-full" formControlName="contact_phone" />
        </fieldset>
      </form>
      <div class="bm-modal-action p-4 mt-0">
        <button class="bm-btn bm-btn-secondary" (click)="showModal = ''">Abbrechen</button>
        <button class="bm-btn bm-btn-primary" (click)="saveContact()">Speichern</button>
      </div>
    </div>
  </dialog>
}

@if (showModal === "customer_contact") {
  <dialog class="bm-modal" open (document:keydown.escape)="showModal = ''">
    <div class="bm-modal-box p-0">
      <div class="flex flex-row p-4">
        <h3 class="flex-fill text-lg font-bold">Kundenkontakt</h3>
      </div>
      <form [formGroup]="customerContactForm" class="px-4">
        <fieldset class="bm-fieldset">
          <label class="bm-fieldset-label">Anrede</label>
          <select class="bm-select w-full" formControlName="customer_contact_salutation">
            <option value="">ohne</option>
            <option value="Herr">Herr</option>
            <option value="Frau">Frau</option>
          </select>

          <label class="bm-fieldset-label">Name</label>
          <input type="text" class="bm-input w-full" formControlName="customer_contact_name" />

          <label class="bm-fieldset-label">E-Mail</label>
          <input type="email" class="bm-input w-full" formControlName="customer_contact_email" />
        </fieldset>
      </form>
      <div class="bm-modal-action p-4 mt-0">
        @if (hasCustomerContact) {
          <button class="bm-btn bm-btn-error bm-btn-outline mr-auto" (click)="removeCustomerContact()">
            Kontakt entfernen
          </button>
        }
        <button class="bm-btn bm-btn-secondary" (click)="showModal = ''">Abbrechen</button>
        <button class="bm-btn bm-btn-primary" (click)="saveCustomerContact()">Speichern</button>
      </div>
    </div>
  </dialog>
}

@if (showModal === "status") {
  <dialog class="bm-modal" open (document:keydown.escape)="showModal = ''">
    <div class="bm-modal-box p-0 w-11/12 max-w-4xl">
      <div class="p-5 pb-3">
        <h3 class="text-lg font-bold">Status ändern</h3>
        <p class="text-sm text-base-content/70">
          Ticket {{ ticket?.order_nr }} im Projekt {{ ticket?.project_name }}
        </p>
      </div>
      <form [formGroup]="statusForm" class="px-5">
        <hawk-status-picker
          formControlName="status_id"
          [statuses]="metaData?.status_list"
          [currentStatusId]="metaData?.status?.id"
          [isOptionDisabled]="isMtStatusDisabled"
        />
      </form>
      <div class="bm-modal-action p-5 mt-0">
        <button class="bm-btn bm-btn-secondary" (click)="closeModal()">Abbrechen</button>
        <button class="bm-btn bm-btn-primary" (click)="saveStatus()">Status setzen</button>
      </div>
    </div>
  </dialog>
}

@if (showModal === "quick_actions") {
  <dialog class="bm-modal" open (document:keydown.escape)="showModal = ''; confirmResetWithTimes = false">
    <div class="bm-modal-box p-0">
      <div class="p-4">
        <h3 class="flex-fill text-lg font-bold">Schnellaktionen</h3>
      </div>
      <div class="px-4">
        <div class="bm-card bm-card-border border-base-300 p-4">
          <h4 class="font-semibold mb-2">Ticket zurücksetzen</h4>
          <p class="text-sm text-base-content/80 mb-4">
            Beim Zurücksetzen wird der eingeplante Techniker entfernt und auf "nicht vergeben" gesetzt, der Einsatz auf
            das Fallback-Datum des Projekts verschoben und der Status auf den Fallback-Status (ungeplant) gesetzt. Das
            Ticket landet damit wieder in der offenen Disposition.
          </p>
          <button class="bm-btn bm-btn-primary" (click)="resetTicketAction()">
            <fa-icon [icon]="['fas', 'bolt']" /> Ticket zurücksetzen
          </button>
        </div>

        <div class="bm-card bm-card-border border-base-300 p-4 mt-4">
          <h4 class="font-semibold mb-2">Ticket zurücksetzen inkl. Zeiten</h4>
          <p class="text-sm text-base-content/80 mb-4">
            Wie oben, zusätzlich werden die Zeitstempel des Einsatzes gelöscht: Reisebeginn, Startzeit (Ankunft),
            Wiederhergestellt und Abgeschlossen — inklusive der Pauschal-Zeiten der Abrechnung. Verwenden, wenn der
            Einsatz gar nicht stattgefunden hat und das Ticket komplett neu geplant wird.
          </p>
          @if (!confirmResetWithTimes) {
            <button class="bm-btn bm-btn-warning" (click)="confirmResetWithTimes = true">
              <fa-icon [icon]="['fas', 'bolt']" /> Ticket zurücksetzen inkl. Zeiten
            </button>
          } @else {
            <div class="flex items-center gap-2">
              <span class="text-sm font-semibold">Zeitstempel wirklich löschen?</span>
              <button class="bm-btn bm-btn-warning bm-btn-sm" (click)="resetTicketAction(true)">Ja, zurücksetzen</button>
              <button class="bm-btn bm-btn-ghost bm-btn-sm" (click)="confirmResetWithTimes = false">Abbrechen</button>
            </div>
          }
        </div>
      </div>
      <div class="bm-modal-action p-4 mt-0">
        <button class="bm-btn bm-btn-secondary" (click)="showModal = ''; confirmResetWithTimes = false">Schließen</button>
      </div>
    </div>
  </dialog>
}

@if (showModal === "prio") {
  <dialog class="bm-modal" open (document:keydown.escape)="showModal = ''">
    <div class="bm-modal-box p-0">
      <div class="p-4">
        <h3 class="flex-fill text-lg font-bold">Priorität</h3>
      </div>
      <form [formGroup]="prioForm" class="px-4">
        <fieldset class="bm-fieldset">
          <select class="bm-select w-full" formControlName="priority_id">
            @for (prio of metaData?.priority_list; track prio.id) {
              <option [value]="prio.id" [selected]="prio.id === metaData.priority.id">
                {{ prio.name }}
              </option>
            }
          </select>
        </fieldset>
      </form>
      <div class="bm-modal-action p-4 mt-0">
        <button class="bm-btn bm-btn-secondary" (click)="closeModal()">Abbrechen</button>
        <button class="bm-btn bm-btn-primary" (click)="savePrio()">Speichern</button>
      </div>
    </div>
  </dialog>
}

@if (showModal === "time_estimation") {
  <dialog class="bm-modal" open (document:keydown.escape)="showModal = ''">
    <div class="bm-modal-box p-0">
      <div class="p-4">
        <h3 class="flex-fill text-lg font-bold">Kalkulierte Arbeitszeit</h3>
      </div>
      <form [formGroup]="metaTimeForm" class="px-4">
        <fieldset class="bm-fieldset">
          <input class="bm-input w-full" type="number" formControlName="time_estimation" />
        </fieldset>
      </form>
      <div class="bm-modal-action p-4 mt-0">
        <button class="bm-btn bm-btn-secondary" (click)="closeModal()">Abbrechen</button>
        <button class="bm-btn bm-btn-primary" (click)="saveTimeEstimation()">Speichern</button>
      </div>
    </div>
  </dialog>
}

@if (showModal === "appointment") {
  <dialog class="bm-modal" open (document:keydown.escape)="showModal = ''">
    <div class="bm-modal-box p-0">
      <div class="p-4">
        <h3 class="flex-fill text-lg font-bold">Kundentermin bearbeiten</h3>
      </div>
      <form [formGroup]="appointmentForm" class="px-4">
        <fieldset class="bm-fieldset">
          <label class="bm-fieldset-label">Kontaktperson</label>
          <input class="bm-input w-full" type="text" formControlName="appointment_contact" />

          <label class="bm-fieldset-label">Terminvereinbarung</label>
          <input
            type="text"
            class="bm-input w-full"
            mwlFlatpickr
            formControlName="appointment_date"
            [locale]="'de'"
            [options]="datePickerConfig"
            [convertModelValue]="true"
          />
        </fieldset>
      </form>
      <div class="bm-modal-action p-4 mt-0">
        <button class="bm-btn bm-btn-secondary" (click)="closeModal()">Abbrechen</button>
        <button class="bm-btn bm-btn-primary" (click)="saveAppointment()">Speichern</button>
      </div>
    </div>
  </dialog>
}

@if (showModal === "store") {
  <dialog class="bm-modal" open (document:keydown.escape)="showModal = ''">
    <div class="bm-modal-box p-0" [style.maxWidth.rem]="64">
      <div class="flex flex-row p-4">
        <h3 class="flex-fill text-lg font-bold">Store auswählen</h3>
        <div>
          <input class="bm-input" type="text" [(ngModel)]="storeSearchboxValue" placeholder="Store suchen" />
        </div>
      </div>
      <div class="px-4 overflow-auto" [style.maxHeight.vh]="80">
        <table class="bm-table bm-table-xs bm-table-zebra">
          <tr>
            <th>Nr</th>
            <th>Name</th>
            <th>Adresse</th>
          </tr>
          @for (store of metaData.project_stores | storeFilter: storeSearchboxValue | slice: 0 : 25; track $index) {
            <tr (click)="saveStore(store.id)">
              <td>
                {{ store.nr }}
                @if (ticket.store_id == store.id) {
                  <fa-icon [icon]="['far', 'check']" />
                }
              </td>
              <td>{{ store.name }}</td>
              <td>
                {{ store.name }}, {{ store.address_firstname }} {{ store.address_lastname }}<br />
                {{ store.address_street }}, {{ store.address_zip }} {{ store.address_city }},
                {{ store.address_country }}
              </td>
            </tr>
          }
        </table>
      </div>
      <div class="bm-modal-action p-4 mt-0">
        <button class="bm-btn bm-btn-secondary" (click)="showModal = ''">Abbrechen</button>
        <button class="bm-btn bm-btn-primary" (click)="removeStore()">Store zurücksetzen</button>
      </div>
    </div>
  </dialog>
}

@if (showModal === "delete") {
  <dialog class="bm-modal" open (document:keydown.escape)="showModal = ''">
    <div class="bm-modal-box p-0" [style.maxWidth.rem]="64">
      <div class="p-4">
        <h3 class="flex-fill text-lg font-bold">Löschen!</h3>
      </div>

      <div class="px-4 flex flex-col gap-2 overflow-auto" [style.maxHeight.vh]="80">
        <div>
          Die hier angezeigten Operationen sind <b>destruktiv</b>, sie können nicht rückgängig gemacht werden. Bevor der
          Link unten geklickt wird, sollte man sich <b>sehr</b> sicher sein, dass man wirklich löschen möchte.
        </div>

        <div class="text-lg font-bold mt-2">Ticket löschen</div>
        <button
          class="bm-btn w-full"
          [class.bm-btn-warning]="ticketDeletable()"
          [class.bm-btn-disabled]="!ticketDeletable()"
          (click)="deleteTicket()"
          [disabled]="!ticketDeletable()"
        >
          Ich möchte das Ticket {{ ticket.order_nr }} ({{ ticket.id }}) löschen
        </button>
        @if (!ticketDeletable()) {
          <div class="text-xs">
            Kann nicht gelöscht werden, weil Ticket Einsätze besitzt oder aus anderem Grund gesperrt ist.
          </div>
        }

        @if (operations && operations.length > 0) {
          <div class="text-lg font-bold mt-2">Einsatz löschen</div>
          @for (operation of operations; track $index) {
            <div>
              <button
                class="bm-btn w-full"
                [class.bm-btn-error]="operationDeletable(operation)"
                [class.bm-btn-disabled]="!operationDeletable(operation)"
                (click)="deleteOperation(operation)"
                [disabled]="!operationDeletable(operation)"
              >
                Ich möchte den Einsatz {{ operation.tech_short }}
                {{ operation.operation_date | date: "dd.MM.yyyy HH:mm" }} ({{ operation.id }}) löschen
              </button>
              @if (!operationDeletable(operation)) {
                <div class="text-xs">Kann nicht gelöscht werden, weil Einsatz schon bearbeitet wurde.</div>
              }
            </div>
          }
        }

        <div class="text-lg font-bold mt-2">Ticket und alle Einsätze löschen, ohne Prüfung</div>
        @if (ticket.is_mt) {
          <div>
            Vorsicht MT-Ticket. Bitte besondere Vorsicht walten lassen und prüfen, ob schon Rückmeldungen an MT
            geschickt wurden!
          </div>

          <div>Wurden Rückmeldungen gesendet, muss sehr aufgepasst werden!</div>
        }
        @if (operations && operations.length > 0) {
          @for (operation of operations; track operation.id) {
            <div>Nur Einsatz {{ operation.id }} löschen</div>
            <button class="bm-btn bm-btn-error w-full" (click)="dangerousDeleteOperation(operation.id)">
              Löschen ohne Prüfung (Einsatz {{ operation.id }})
            </button>
          }
        }
        @if (ticket.delivery_notes && ticket.delivery_notes.length > 0) {
          Es sind Lieferscheine diesem Ticket zugewiesen. Beim Löschen wird die Zuordnung aufgelöst, aber der
          Lieferschein bleibt bestehen.
          @for (deliveryNote of ticket.delivery_notes; track deliveryNote.id) {
            <div>
              <a [routerLink]="['/', 'lieferscheine', deliveryNote.id]" target="_new">
                <fa-icon [icon]="['far', 'truck']" /> {{ deliveryNote.number }}
              </a>
            </div>
          }
        }

        <div class="text-lg font-bold mt-2">Ticket und Einsätze</div>
        <button class="bm-btn bm-btn-error w-full" (click)="dangerousDelete()">
          Löschen ohne Prüfung ist gefährlich. Ich bin mir sicher was ich mache.
        </button>
      </div>
      <div class="bm-modal-action p-4 mt-0">
        <button class="bm-btn bm-btn-secondary" (click)="showModal = ''">Abbruch</button>
      </div>
    </div>
  </dialog>
}

@if (showModal === "ticket_group") {
  <dialog class="bm-modal" open (document:keydown.escape)="showModal = ''">
    <div class="bm-modal-box p-0">
      <div class="px-4 flex flex-col gap-2 overflow-auto" [style.maxHeight.vh]="80">
        <div class="py-4 flex flex-row">
          <h3 class="flex-fill text-lg font-bold me-auto">Tickets hinzufügen</h3>
          <a class="bm-link" [routerLink]="'/ticket/suche/index'" target="_new">Ticket-Suche</a>
        </div>
        <fieldset class="bm-fieldset">
          <label class="bm-fieldset-label">HAWK IDs</label>
          <input
            type="text"
            class="bm-input w-full"
            [(ngModel)]="addHawkIdsToTicketGroup"
            placeholder="FSP-23-115087;FSP-23-115089;..."
            (ngModelChange)="onTicketGroupHawkIdsInputChanged()"
          />
        </fieldset>

        @if (addTicketsToTicketGroup?.length) {
          <div class="overflow-y-auto" [style.max-height.px]="400">
            <table class="bm-table bm-table-sm bm-table-pin-rows">
              <thead>
                <tr>
                  <th>Ticket</th>
                  <th>Info</th>
                  <th>Wird hinzugefügt</th>
                </tr>
              </thead>
              <tbody>
                @for (item of addTicketsToTicketGroup; track $index) {
                  <tr>
                    <td>
                      <a class="bm-link" [routerLink]="['/ticket/', item.ticket.id]" target="_new">{{
                        item.ticket.order_nr
                      }}</a>
                    </td>
                    <td>{{ item.info }}</td>
                    <td>{{ item.add_to_group ? "Ja" : "Nein" }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>

      <div class="bm-modal-action p-4 mt-0 gap-1">
        <button
          class="bm-btn bm-btn-primary"
          [disabled]="!addTicketsToTicketGroup?.length || saveTicketGroupProcess"
          (click)="saveTicketsToTicketGroup()"
        >
          Speichern
        </button>
        <button class="bm-btn bm-btn-secondary" (click)="showModal = ''">Abbruch</button>
      </div>
    </div>
  </dialog>
}

<!-- Modal with sample content and everything activated -->
<!-- <div class="modal is-active has-toolbar" role="dialog" aria-modal="true">
<div class="modal-background"></div>
<div class="modal-content">
  <div class="wrapper">
    <h3>Aktionen</h3>
    <table class="ticketPageTable base">
      <tr>
        <th class="editable">Status</th>
        <td>3.0 geplant</td>
      </tr>
      <tr>
        <th class="editable">Priorität</th>
        <td>NBD</td>
      </tr>
      <tr>
        <th class="editable">Terminvereinbarung</th>
        <td></td>
      </tr>
      <tr>
        <th class="editable">Aufgaben</th>
        <td></td>
      </tr>
      <tr>
        <th class="editable">Abrechnungsbesonderheiten</th>
        <td>vorhanden</td>
      </tr>
      <tr>
        <th>JOB</th>
        <td>aktiv</td>
      </tr>
      <tr>
        <th>Dokumentationen</th>
        <td><a href="#">Sharepoint-Link</a></td>
      </tr>
    </table>
  </div>
  <div class="modal-toolbar">
    <div class="modal-toolbar-container-left">
      <button class="button button-attention">Attention</button>
    </div>
    <div class="modal-toolbar-container-right">
      <button class="button button-secondary">Secondary</button>
      <button class="button">Primary</button>
    </div>
  </div>
</div>
<button class="modal-close" aria-label="close"></button>
</div> -->

<!-- Modal without content, without toolbar and deactivated -->
<!-- <div class="modal" role="dialog" aria-modal="true">
<div class="modal-background"></div>
<div class="modal-content">
  <div class="wrapper">
  </div>
</div>
<button class="modal-close" aria-label="close"></button>
</div> -->

<!-- Modal without content, with toolbar and deactivated -->
<!-- <div class="modal has-toolbar" role="dialog" aria-modal="true">
<div class="modal-background"></div>
<div class="modal-content">
  <div class="wrapper">
  </div>
  <div class="modal-toolbar">
    <div class="modal-toolbar-container-left">
      <button class="button button-attention">Attention</button>
    </div>
    <div class="modal-toolbar-container-right">
      <button class="button button-secondary">Secondary</button>
      <button class="button">Primary</button>
    </div>
  </div>
</div>
<button class="modal-close" aria-label="close"></button>
</div> -->
